import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery } from '@apollo/client';
import { Empty, Spin } from 'antd';
import PropTypes from 'prop-types';
import { GET_DEPARTMENTS } from 'gql/faculties';

const SelectDepartmentOnly = ({ state, ...props }) => {
  const { data, loading } = useQuery(GET_DEPARTMENTS, {
    variables: { state },
  });
  const valueEnum = data?.departments?.reduce(
    (acc, { id, name, abbreviation }) => {
      acc[id] = `${abbreviation} - ${name}`;
      return acc;
    },
    {}
  );

  return (
    <ProFormSelect
      showSearch
      label="Department"
      name="department"
      width="sm"
      valueEnum={valueEnum}
      fieldProps={{
        notFoundContent: loading ? <Spin size="small" /> : <Empty />,
        dropdownMatchSelectWidth: 500,
      }}
      {...props}
    />
  );
};

SelectDepartmentOnly.defaultProps = {
  state: 'ACTIVE',
};
SelectDepartmentOnly.propTypes = {
  state: PropTypes.string.isRequired,
};

export default SelectDepartmentOnly;
